export const handleDragEnd = (result, setCategories) => {
  const { source, destination, draggableId } = result;
  if (!destination) return;
  
  // Drag from unassigned to category
  if (source.droppableId === 'unassigned' && destination.droppableId.startsWith('cat-')) {
    const catId = destination.droppableId.replace('cat-', '');
    setCategories(cs => cs.map(cat =>
      cat.id === catId && !cat.sheets.includes(draggableId)
        ? { ...cat, sheets: [...cat.sheets, draggableId] }
        : cat
    ));
    return;
  }
};

export const removeScenarioFromCategory = (catId, tid, setCategories) => {
  setCategories(cs => cs.map(cat =>
    cat.id === catId
      ? { ...cat, sheets: cat.sheets.filter(id => id !== tid) }
      : cat
  ));
};

export const handleRowDragEnd = (result, template, setTemplate) => {
  if (!result.destination) return;
  
  // Validate that we're working with the correct droppable
  if (result.source.droppableId !== 'scenario-rows' || result.destination.droppableId !== 'scenario-rows') {
    return;
  }
  
  const newRows = Array.from(template.rows);
  const [reorderedItem] = newRows.splice(result.source.index, 1);
  newRows.splice(result.destination.index, 0, reorderedItem);
  setTemplate(prev => ({ ...prev, rows: newRows }));
};

export const handleElementDragEnd = (result, template, setTemplate, startSectionSelection) => {
  if (!result.destination) return;
  
  const { source, destination, draggableId } = result;
  
  // Handle dragging from sidebar to table
  if (source.droppableId === 'sidebar-elements' && destination.droppableId === 'scenario-rows') {
    const newRows = Array.from(template.rows);
    let newElement;
    
    // Handle section total drag - start Excel-like selection
    if (draggableId === 'add-section-total') {
      const targetRow = template.rows[destination.index];
      if (targetRow && (targetRow.type === 'header' || targetRow.type === 'sub-header')) {
        // Start section selection on the target header/sub-header
        startSectionSelection(destination.index, targetRow);
      } else {
        console.log('Please drag the Section Total onto a Header or Sub-Header to begin selection');
      }
      return;
    }
    
    switch (draggableId) {
      case 'add-row':
        newElement = { item: '', objective: '', notes: '', score: '', value: '', critical: false };
        break;
      case 'add-header':
        newElement = { type: 'header', text: 'New Section', item: '', objective: '', notes: '', score: '', value: '', critical: false };
        break;
      case 'add-subheader':
        newElement = { type: 'sub-header', text: 'New Sub-Section', item: '', objective: '', notes: '', score: '', value: '', critical: false };
        break;
      case 'add-description':
        newElement = { type: 'description', text: 'Add your description here...', item: '', objective: '', notes: '', score: '', value: '', critical: false };
        break;
      case 'add-blank-row':
        newElement = { type: 'blank-row', item: '', objective: '', notes: '', score: '', value: '', critical: false };
        break;
      case 'add-stacked-row':
        newElement = {
          type: 'row',
          item: '',
          objective: '',
          notes: '',
          score: '',
          value: '',
          critical: false,
          moduleType: 'stacked-row',
          stackedObjectives: [
            { objective: '', notes: '', score: '', value: '', critical: false, category: '' }
          ]
        };
        break;
      default:
        return;
    }
    
    newRows.splice(destination.index, 0, newElement);
    setTemplate(prev => ({ ...prev, rows: newRows }));
    return;
  }
  
  // Handle normal row reordering
  if (source.droppableId === 'scenario-rows' && destination.droppableId === 'scenario-rows') {
    const newRows = Array.from(template.rows);
    const [reorderedItem] = newRows.splice(source.index, 1);
    newRows.splice(destination.index, 0, reorderedItem);
    setTemplate(prev => ({ ...prev, rows: newRows }));
  }
};
